import { Link } from '@cian/link-component';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';
import { IAddressPathItemTracking } from './tracking';

const style = require('./index.css');

export type TAddressPathItem = 'address' | 'metro';

interface IAddresPathProps {
  label: string;
  qs: string;
  type: TAddressPathItem;
  url?: string;
  className?: string;
  trackAddressClick?: IAddressPathItemTracking['trackAddressClick'];
}

export class AddressPathItem extends React.Component<IAddresPathProps> {

  public render() {
    const { label, qs, url } = this.props;
    const href = url || `/cat.php?${qs}`;

    return (
      <Link
        {...mergeStyles([
          style['item'],
          this.props.className,
        ])}
        key={`offer-card-${qs}`}
        href={href}
        onClick={this.trackClickEvent}
        target="_blank"
      >
        {label}
      </Link>
    );
  }

  private trackClickEvent = () => {
    const {
      trackAddressClick,
      type,
    } = this.props;

    if (trackAddressClick) {
      trackAddressClick(type);
    }
  }

}
